<template lang="pug">
	#kioskSharingPage
		Navbar(tab="devices" :siteId="navbarSiteId" :site="site")
		main(v-if="isAdmin")
			.container
				.app-page-breadcrumbs
					AppBreadcrumbs(label="Devices" :allow-all-sites="true" :site-id="breadcrumbSiteId")
				v-row.top-header
					.col.s12.site-info
						.site-image(v-if="selectedSite" :style='"background-image:url(" + (selectedSite.logo ? selectedSite.logo.url.replace("http", "https") : "") + ")"')
						.site-title {{ pageTitle }}
				v-row
					v-col
						v-data-table.elevation-8.haq-data-table(v-model="devices" show-select item-key="objectId" :search="search" :headers="tableHeaders" :items="dtDevices" :loading="loading" :items-per-page="10")
							template(v-slot:top)
								v-row.align-center.devices-table-toolbar
									v-col(sm="5")
										HaqTextField(
											append-icon="mdi-magnify"
											v-model="search"
											placeholder="Search Devices"
											hide-details
										)
							template(v-slot:item.edit="{ item }")
								v-icon(small class="mr-2" @click="openEditModal(item)") mdi-dots-vertical
							template(v-slot:item.rssi="{ item }")
								v-tooltip(top)
									template(v-slot:activator="{on,attrs}")
										v-icon(v-if="item.rssi <= 0 && item.rssi >= -60" class="mr-2" @click="openEditModal(item)" v-bind="attrs" v-on="on") mdi-signal-cellular-3
										v-icon(v-else-if="item.rssi <= -60 && item.rssi >= -85" class="mr-2" @click="openEditModal(item)" v-bind="attrs" v-on="on") mdi-signal-cellular-2
										v-icon(v-else-if="item.rssi <= -85" class="mr-2" @click="openEditModal(item)" v-bind="attrs" v-on="on") mdi-signal-cellular-1
										v-icon(v-else class="mr-2" @click="openEditModal(item)" v-bind="attrs" v-on="on") mdi-signal-cellular-outline
									span {{item.rssi}}
							template(v-slot:item.zone="{ item }")
								router-link(v-if="item.zoneId && item.siteId" :to="{name: 'Zone', params: {projectId: projectId, siteId: item.siteId, zoneId: item.zoneId}}" target="_blank") {{item.zone}}
								span(v-else) {{item.zone}}
							template(v-slot:item.lastTrendData="{ item }")
								v-tooltip(top)
									template(v-slot:activator="{ on, attrs }")
										span(v-bind="attrs" v-on="on") {{formatLastHeardFromRelative(item.lastHeardFrom)}}
									span {{formatLastHeardFromAbsolute(item.lastHeardFrom)}}
		DeviceModal(v-if="currentDialog == 'edit'" :action="currentDialog" :device="dtDevices[deviceIndex]" v-on:closeDeviceModal="closeDeviceModal")
</template>
<script>
import Navbar from '@/components/Navbar.vue';
import DonutIndicator from '@/components/DonutIndicator.vue';
import {HTTPClient} from '../assets/js/http';
import {useGetSite} from '../assets/js/hawken-query'
import DeviceModal from '@/components/modals/Device.vue'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import HaqTextField from '@/components/form/HaqTextField.vue'
let client = new HTTPClient();

export default {
	name: 'Devices',
	components: {
		Navbar,
		DonutIndicator,
		DeviceModal,
		AppBreadcrumbs,
		HaqTextField,
	},
	data(){
		return {
			siteId: this.$route.params.siteId ? this.$route.params.siteId : this.$route.query.siteId,
			site: null,
			selectedSite: null,
			search: "",
			devices: [],
			searchDevices: '',
			loading: false,
			dtDevicesHeaders: [
				{text: 'Device Name', value: 'deviceName'},
				{text: 'Model Name', value: 'name'},
				{text: 'Device ID', value: 'deviceId'},
				{text: 'IP Address', value: 'ipAddress'},
				{text: 'MAC Address', value: 'macAddress'},
				{text: 'RSSI', value: 'rssi'},
				{text: 'Zone', value: 'zone'},
				{text: 'Connected', value: 'connected'},
				{text: 'Last Heard From', value: 'lastTrendData'},
				{text: '', value: 'edit'},
			],
			dtDevices: [],
			deviceIndex: 0,
			currentDialog: null,
		};
	},
	computed: {
		/**
		 * True when the current user is an admin or superAdmin.
		 * @returns {boolean}
		 */
		isAdmin() {
			const role = this.resolveUser()?.role;
			return role === 'admin' || role === 'superAdmin';
		},
		/**
		 * Site id for navbar context (selected or first available site).
		 * @returns {string|null}
		 */
		navbarSiteId() {
			return this.$route.query.siteId || this.$route.params.siteId || this.site?.objectId || null;
		},
		/**
		 * Site id for the All Sites breadcrumb (query only; default is All Sites).
		 * @returns {string|null}
		 */
		breadcrumbSiteId() {
			return this.$route.query.siteId || null;
		},
		/**
		 * Current project object id from route or store.
		 * @returns {string|null}
		 */
		projectId() {
			return this.$route.params.projectId || this.$store.state.project?.objectId || null;
		},
		/**
		 * Display name for the current project.
		 * @returns {string}
		 */
		projectName() {
			const projectId = this.projectId;
			if (projectId && this.$store.state.projects?.length) {
				const current = this.$store.state.projects.find(p => p.objectId === projectId);
				if (current) return current.name;
			}
			return this.$store.state.project?.name || 'Project';
		},
		/**
		 * Page title for All Sites vs a selected site.
		 * @returns {string}
		 */
		pageTitle() {
			if (this.selectedSite && this.selectedSite.name) return `${this.selectedSite.name} Devices`;
			return `${this.projectName} Devices`;
		},
		/**
		 * Table headers, with Site when viewing All Sites.
		 * @returns {Array}
		 */
		tableHeaders() {
			const headers = this.dtDevicesHeaders.slice();
			if (!this.breadcrumbSiteId) {
				const zoneIndex = headers.findIndex(h => h.value === 'zone');
				headers.splice(zoneIndex >= 0 ? zoneIndex : headers.length - 1, 0, { text: 'Site', value: 'siteName' });
			}
			return headers;
		},
		showDevice(){
			return (d) => {
				let regex = new RegExp(this.search, 'i');
				return regex.test(d.deviceName) || regex.test(d.name)
			}
		}
	},
	methods: {
		/**
		 * Resolve the current user from the store or localStorage.
		 * @returns {Object|null}
		 */
		resolveUser() {
			let user = this.$store.state.user;
			if (user) return user;
			try {
				const raw = localStorage.getItem('user');
				if (!raw) return null;
				user = JSON.parse(raw);
				this.$store.commit('setUser', user);
				return user;
			} catch (error) {
				return null;
			}
		},
		/**
		 * Redirect non-admins away once the user record is known.
		 * @returns {boolean} true when the page may continue loading
		 */
		guardAdmin() {
			const user = this.resolveUser();
			if (!user) return false;
			if (user.role !== 'admin' && user.role !== 'superAdmin') {
				this.$router.replace('/');
				return false;
			}
			return true;
		},
		/**
		 * Load a site into navbar context (project-level page).
		 */
		async loadSiteContext() {
			try {
				if (this.$store.state.site) {
					this.site = this.$store.state.site;
					return;
				}
				let sites = this.$store.state.sites;
				if (!sites || sites.length === 0) {
					const res = await client.robustQuery('/api', { slim: true });
					sites = res.sites || [];
					this.$store.commit('setSites', sites);
				}
				if (sites.length > 0) {
					this.site = {
						objectId: sites[0].objectId,
						name: sites[0].name,
						commanderLicenseId: sites[0].commanderLicenseId || null,
						project: sites[0].project || null,
						canBeScheduled: sites[0].canBeScheduled || false
					};
				}
			} catch (error) {
				console.error('Failed to load site context', error);
			}
		},
		/**
		 * Load the breadcrumb site for the header image and title.
		 */
		async getSelectedSite() {
			const siteId = this.breadcrumbSiteId;
			if (!siteId) {
				this.selectedSite = null;
				return;
			}
			try {
				this.selectedSite = await useGetSite(siteId)
			} catch (error) {
				this.selectedSite = null;
				window.M.toast({html: "Error in fetching site"})
			}
		},
		/**
		 * Map a Device API row to the table model.
		 * @param {Object} x
		 * @returns {Object}
		 */
		mapDeviceRow(x) {
			return {
				serialNum: x.serialNumber || '',
				name: x.deviceType?.friendlyModelName,
				rssi: x.rssi,
				zone: x.zone?.name,
				zoneId: x.zone?.objectId,
				siteName: x.site?.name || '',
				siteId: x.site?.objectId || this.breadcrumbSiteId,
				// device is connected if lastHeardFrom within the hour
				connected: x.lastHeardFrom ? (new Date() - new Date(x.lastHeardFrom)) < 3600000 : false,
				// connected: x.zone?.connected ? 'True' : 'False',
				lastHeardFrom: x.lastHeardFrom,
				lastTrendData: x.lastHeardFrom ? new Date(x.lastHeardFrom).toTimeString() : x.lastHeardFrom,
				deviceName: x.name,
				deviceId: x.connectionMetadata?.id || '',
				ipAddress: x.metadata?.ip || x.connectionMetadata?.ip || '',
				macAddress: x.metadata?.mac || x.connectionMetadata?.mac || x.connectionMetadata?.id || '',
				objectId: x.objectId,
				metadata: x.metadata,
				edgeDeviceId: x.edgeDevice?.objectId || null,
				edgeInstallationId: x.edgeInstallation?.objectId || null,
				dataConnectionId: x.dataConnection?.objectId || null
			}
		},
		/**
		 * Fetch devices for the project, or one site when selected.
		 */
		async getDevices() {
			if (!this.projectId || !this.isAdmin) return;
			this.loading = true;
			try {
				const params = {};
				if (this.breadcrumbSiteId) params.siteId = this.breadcrumbSiteId;
				let devices = await client.robustQuery(`/api/projects/${this.projectId}/devices`, params);
				this.dtDevices = (devices.results || []).map(x => this.mapDeviceRow(x));
			} catch (error) {
				console.error(error);
				this.dtDevices = [];
				window.M.toast({html: "Error in fetching devices"})
			} finally {
				this.loading = false;
			}
		},
		/**
		 * Human-friendly relative time for the devices table.
		 * @param {string} timestamp - ISO timestamp string
		 * @returns {string}
		 */
		formatLastHeardFromRelative(timestamp) {
			if (!timestamp) return '';
			const ms = Date.now() - new Date(timestamp).getTime();
			if (Number.isNaN(ms)) return '';
			const sec = Math.max(0, Math.floor(ms / 1000));
			if (sec < 60) return `${sec}s ago`;
			const min = Math.floor(sec / 60);
			if (min < 60) return `${min}m ago`;
			const hr = Math.floor(min / 60);
			if (hr < 24) return `${hr}h ago`;
			const day = Math.floor(hr / 24);
			if (day < 30) return `${day}d ago`;
			const month = Math.floor(day / 30);
			if (month < 12) return `${month}mo ago`;
			return `${Math.floor(month / 12)}y ago`;
		},
		/**
		 * Full timestamp for hover tooltip.
		 * @param {string} timestamp - ISO timestamp string
		 * @returns {string}
		 */
		formatLastHeardFromAbsolute(timestamp) {
			if (!timestamp) return '';
			const date = new Date(timestamp);
			const dateStr = date.toLocaleDateString();
			const timeStr = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true });
			const timezoneStr = date.toLocaleTimeString('en-US', { timeZoneName: 'short' }).split(' ').pop();
			return `${dateStr} ${timeStr} ${timezoneStr}`;
		},
		openEditModal(device) {
			this.currentDialog = 'edit';
			this.deviceIndex = this.dtDevices.indexOf(device)
		},
		closeDeviceModal() {
			this.currentDialog = null;
			this.deviceIndex = 0;
		},
		/**
		 * Sync site from the route and reload page data.
		 */
		reloadFromRoute() {
			if (!this.guardAdmin()) return;
			if (this.$route.name === 'DevicesLegacy' && this.projectId) {
				this.$router.replace({
					path: `/projects/${this.projectId}/devices`,
					query: this.$route.query
				}).catch(function() { /* ignore */ });
				return;
			}
			this.siteId = this.breadcrumbSiteId;
			this.loadSiteContext();
			this.getSelectedSite();
			this.getDevices();
		},
	},
	mounted() {		
		this.reloadFromRoute();
	},
	watch: {
		'$route.query.siteId'() {
			this.reloadFromRoute();
		},
		'$route.params.siteId'() {
			this.reloadFromRoute();
		},
		'$route.params.projectId'() {
			this.reloadFromRoute();
		},
		/**
		 * Re-check admin access when the store user arrives after mount.
		 * @param {Object|null} user
		 */
		'$store.state.user'(user) {
			if (!user) return;
			if (!this.guardAdmin()) return;
			if (!this.site) this.loadSiteContext();
			if (!this.dtDevices.length) this.getDevices();
		}
	}
};
</script>
<style lang="scss" scoped>
	.container-lg {
		@media only screen and (min-width: 993px) {
			width: 100%;
		}
	}
	
	.top-header {
		margin-top: 16px;
		margin-bottom: 0;
		.site-info {
			display: flex;
			align-items: center;
			margin-bottom: 20px;
			.site-image {
				border-radius: 20px;
				width: 120px;
				height: 80px;
				min-width: 120px;
				min-height: 80px;
				background-size: cover;
				background-position: 50% 50%;
				background-repeat: no-repeat;
				vertical-align: top;
				margin-right: 2rem;
			}
			.site-progress {
				margin-right: 1.5rem;
			}			
			.site-title {
				color: var(--app-primary-txt);
				font-size: 28px;
				.siteLink {
					color: var(--app-primary-txt);
					&:hover {
						text-decoration: underline;
					}
				}
			}
		}
	}

	.devices-table-toolbar {
		margin-bottom: 16px;
	}
</style>